const makePostErrorViewedData = data => ({
  userId: data.userId,
  productId: data.productId,
  errorType: data.errorType
});

export { makePostErrorViewedData };
